"use client";

import React, { useState, useEffect, useRef } from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import Snackbar from "@mui/material/Snackbar";
import { ApprovalIcon } from "@directv-digital/fusion.atoms.icons";
// Generated by Copilot- Start - 2026-04-01 20:31:38
import { useMiniPopupState } from '@directv-digital/dds.server.application-context';
// Generated by Copilot- End - 2026-04-01 20:31:38
// eslint-disable-next-line import/no-extraneous-dependencies
import { Transition } from "react-transition-group";
import { useBreakPoints } from "@directv-digital/dds.utils";

const duration = 300;
const defaultStyle = {
  transition: `opacity ${duration}ms, transform ${duration}ms`,
  opacity: 0,
  transform: "translateX(100%)"
};

const transitionStyles: any = {
  entering: {
    opacity: 1,
    transform: "translateX(0)"
  },
  entered: {
    opacity: 1,
    transform: "translateX(0)"
  },
  exiting: {
    opacity: 0,
    transform: "translateX(100%)"
  },
  exited: {
    opacity: 0,
    transform: "translateX(100%)"
  }
};

function FadeSlideTransition(props: any) {
  const { in: inProp, children, ...other } = props;
  return (
    <Transition in={inProp} timeout={duration} {...other}>
      {(state: string) => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          {children}
        </div>
      )}
    </Transition>
  );
}

export interface DtvSnackBarProps {
  miniPopupVal?: any;
  open?: boolean;
  sxOverride?: any;
  topPx?: number;
};

const DEFAULT_SNACKBAR_POSITION = {
  top: {
    xs: "85px !important",
    sm: "170px !important"
  }
};

export function DtvSnackBar(props: DtvSnackBarProps) {
  try {
    const { miniPopupVal, sxOverride } = props;
    const { isMobile } = useBreakPoints();
    const { backgroundColor, textColor, message } = miniPopupVal?.[0] || {}
    // Generated by Copilot- Start - 2026-04-01 20:31:38
    const { value: showSnackbar } = useMiniPopupState();
    // Generated by Copilot- End - 2026-04-01 20:31:38
    const effectiveOpen = props.open !== undefined ? props.open : showSnackbar;
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarPosition, setSnackbarPosition] = useState(DEFAULT_SNACKBAR_POSITION);
    const snackbarRef = useRef<HTMLDivElement | null>(null);

    const handleCloseSnackbar = () => {
      setSnackbarOpen(false);
    };

    useEffect(() => {
      if (effectiveOpen) {
        setSnackbarOpen(true);
      } else {
        setSnackbarOpen(false);
      }
    }, [effectiveOpen]);

    useEffect(() => {
      const adjustSnackbarPosition = () => {
        try {
          const snackbar = snackbarRef.current;
          const mainContent = document.getElementById('mainContent');
          if (!snackbar || !mainContent) {
            return;
          }

          const ctaElements = Array.from(document.querySelectorAll('.MuiButton-root'))
            .filter(cta => {
              const style = window.getComputedStyle(cta);
              const isInNavBar = cta.closest('#navBar');
              return style.display !== 'none' && !isInNavBar;
            });

          const mainContentRect = mainContent.getBoundingClientRect();
          let newTop = 0;
          const offset = 10;
          let maxIterations = 20;
          let overlapDetected = true;

          // eslint-disable-next-line no-plusplus
          while (overlapDetected && maxIterations-- > 0) {
            snackbar.style.top = `${newTop}px`;
            const snackbarRect = snackbar.getBoundingClientRect();

            const isInsideMainContent =
              snackbarRect.top >= mainContentRect.top &&
              snackbarRect.bottom <= mainContentRect.bottom;

            if (!isInsideMainContent) {
              newTop = mainContentRect.top + offset;
              continue;
            }

            overlapDetected = ctaElements.some(cta => {
              const ctaRect = cta.getBoundingClientRect();
              return !(
                snackbarRect.bottom < ctaRect.top ||
                snackbarRect.top > ctaRect.bottom ||
                snackbarRect.right < ctaRect.left ||
                snackbarRect.left > ctaRect.right
              );
            });

            if (overlapDetected) {
              const overlappingCTAs = ctaElements.filter(cta => {
                const ctaRect = cta.getBoundingClientRect();
                return !(
                  snackbarRect.bottom < ctaRect.top ||
                  snackbarRect.top > ctaRect.bottom ||
                  snackbarRect.right < ctaRect.left ||
                  snackbarRect.left > ctaRect.right
                );
              });

              const maxBottom = Math.max(...overlappingCTAs.map(cta => cta.getBoundingClientRect().bottom));
              newTop = maxBottom + offset;
            }
          }

          setSnackbarPosition({
            top: {
              xs: `${newTop}px !important`,
              sm: `${newTop}px !important`
            }
          });
        } catch (error) {
          console.error("Error adjusting snackbar position:", error);
          setSnackbarPosition(DEFAULT_SNACKBAR_POSITION);
        }
      };

      if (props.open !== undefined) {
        const snackbar = snackbarRef.current;
        if (snackbar && props.topPx !== undefined) {
          // Use setProperty with 'important' so it overrides the !important in sx
          snackbar.style.setProperty('top', `${props.topPx}px`, 'important');
        }
        return;
      }

      adjustSnackbarPosition();
      window.addEventListener('resize', adjustSnackbarPosition);

      return () => {
        window.removeEventListener('resize', adjustSnackbarPosition);
      };
    }, [snackbarOpen, props.open, props.topPx]);

    return effectiveOpen && (
      <Snackbar
        TransitionComponent={FadeSlideTransition}
        autoHideDuration={props.open !== undefined ? null : 4000}
        open={snackbarOpen}
        ref={snackbarRef}
        anchorOrigin={{
          vertical: "top",
          horizontal: isMobile ? "center" : "right"
        }}
        message={
          <span style={{
 display: "flex",
alignItems: "center",
gap: "10px",
height: "32px"
}}>
            <ApprovalIcon fill={"#2AA277"} />
            {message}
          </span>
        }
        sx={{
          ".MuiSnackbar-root, .MuiSnackbar-anchorOriginTopRight": {
            position: "fixed !important",
            top: {
              xs: `${snackbarPosition.top.xs}`,
              sm: `${snackbarPosition.top.sm}`
            },
            left: "unset !important",
            right: "24px !important",
            transform: "none !important",
            width: {
              xs: "395px !important",
              sm: "400px !important"
            },
            height: "auto",
            padding: "16px",
            zIndex: 1400
          },
          ".MuiSnackbarContent-root": {
            backgroundColor: `${backgroundColor} !important`,
            color: `${textColor} !important`
          },
          ...sxOverride
        }}
        onClose={handleCloseSnackbar}      />
    );
  } catch (error) {
    console.error(`Error in Snack Bar Component >> ${error}`);
    return <ErrorDisplay component="Snack Bar Component" error={error} />;
  }
}
